import { render, staticRenderFns } from "./GenericForm.vue?vue&type=template&id=523e45b8&scoped=true"
import script from "./GenericForm.vue?vue&type=script&lang=js"
export * from "./GenericForm.vue?vue&type=script&lang=js"
import style0 from "./GenericForm.vue?vue&type=style&index=0&id=523e45b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e45b8",
  null
  
)

export default component.exports